import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useDisclosure } from "../../hooks/useDisclosure";

function PublicNavbar() {
  const menu = useDisclosure();

  return (
    <nav className="bg-dark-bg/95 backdrop-blur-md border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-5 py-7 flex items-center justify-between">
        <Link
          to="/"
          id="logo-nav"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/DataRevival_REV_RGB.svg"
            alt="Data Revival Logo"
            className="w-[150px] md:w-[180px] h-auto"
          />
        </Link>

        {/* burger icon */}
        <button
          className="md:hidden text-white hover:text-[#00A3FF] focus:outline-none transition-colors duration-200"
          onClick={menu.toggle}
          aria-label="Toggle menu"
        >
          {menu.isOpen ? (
            <X className="w-7 h-7" />
          ) : (
            <Menu className="w-7 h-7" />
          )}
        </button>

        {/* desktop menu */}
        <ul className="hidden md:flex items-center gap-8">
          <li>
            <Link
              className="text-gray-300 hover:text-[#00A3FF] transition-colors duration-200 font-medium"
              to="/howItWorks"
            >
              How it works
            </Link>
          </li>

          <li>
            <Link
              className="text-gray-300 hover:text-[#00A3FF] transition-colors duration-200 font-medium"
              to="/pricingPlans"
            >
              Pricing
            </Link>
          </li>

          <li>
            <a
              className="text-gray-300 hover:text-[#00A3FF] transition-colors duration-200 font-medium"
              href="/about"
            >
              About us
            </a>
          </li>

          <li>
            <a
              className="text-gray-300 hover:text-[#00A3FF] transition-colors duration-200 font-medium"
              href="/blog"
            >
              Blog
            </a>
          </li>

          <li className="flex items-center">
            <Link
              className="text-gray-300 hover:text-[#00A3FF] transition-colors duration-200 font-medium"
              to="/contact"
            >
              Contact
            </Link>
          </li>

          <li className="border-r border-white/20 h-6" />

          <li>
            <Link
              className="text-gray-300 hover:text-white transition-colors duration-200 font-medium"
              to="/login"
            >
              Sign in
            </Link>
          </li>

          <li>
            <Link
              className="bg-gradient-to-r from-[#00A3FF] to-[#0077CC] hover:shadow-lg hover:shadow-[#00A3FF]/30 text-white font-semibold text-sm transition-all duration-200 px-5 py-2.5 rounded-lg"
              to="/pricingPlans"
            >
              Get started
            </Link>
          </li>
        </ul>
      </div>

      {/* mobile menu */}
      {menu.isOpen && (
        <div className="md:hidden bg-dark-bg/95 backdrop-blur-md border-t border-white/10">
          <ul className="flex flex-col py-4">
            <li>
              <Link
                className="text-gray-300 hover:text-[#00A3FF] hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                to="/howItWorks"
                onClick={menu.close}
              >
                How it works
              </Link>
            </li>

            <li>
              <Link
                className="text-gray-300 hover:text-[#00A3FF] hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                to="/pricingPlans"
                onClick={menu.close}
              >
                Pricing
              </Link>
            </li>

            <li>
              <a
                className="text-gray-300 hover:text-[#00A3FF] hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                href="/about"
                onClick={menu.close}
              >
                About us
              </a>
            </li>

            <li>
              <a
                className="text-gray-300 hover:text-[#00A3FF] hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                href="/blog"
                onClick={menu.close}
              >
                Blog
              </a>
            </li>

            <li>
              <Link
                className="text-gray-300 hover:text-[#00A3FF] hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                to="/contact"
                onClick={menu.close}
              >
                Contact
              </Link>
            </li>

            <li className="border-t border-white/10 my-2" />

            <li>
              <Link
                className="text-gray-300 hover:text-white hover:bg-white/5 transition-all duration-200 block px-5 py-3 font-medium"
                to="/login"
                onClick={menu.close}
              >
                Sign in
              </Link>
            </li>

            <li className="px-5 py-3">
              <Link
                className="bg-gradient-to-r from-[#00A3FF] to-[#0077CC] hover:shadow-lg hover:shadow-[#00A3FF]/30 text-white font-semibold text-sm transition-all duration-200 px-5 py-3 rounded-lg block text-center"
                to="/pricingPlans"
                onClick={menu.close}
              >
                Get started
              </Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default PublicNavbar;
